import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  // 定义状态
  ifProcess: false,  // 是否正在输出内容
  ifDeepThink: false,  // 是否深度思考
  conversationId: '',  // 当前会话ID
  theme: '',  // 主题 dark | light
  layout: '', // 布局 fullscreen | minimized
  userId: '',  // 当前用户ID
  appKey: '',  // 当前应用ID
  userName: '',  // 当前用户名称
  ifPcStyle: true, // 是否展示全屏按钮
}

const mutations = {
  // 定义改变状态的方法
  setIfProcess(state, ifProcess) {
    state.ifProcess = ifProcess
  },
  setIfDeepThink(state, ifDeepThink) {
    state.ifDeepThink = ifDeepThink
  },
  setConversationId(state, conversationId) {
    state.conversationId = conversationId
  },
  setIfPcStyle(state, ifPcStyle) {
    state.ifPcStyle = ifPcStyle
  },
  setQueryData(state, queryData) {
    state.userId = queryData.userId
    state.appKey = queryData.appKey
    state.userName = queryData.userName
    state.layout = queryData.layout
    state.theme = queryData.theme
    state.ifDeepThink = queryData.ifDeepThink
    state.ifPcStyle = queryData.ifPcStyle == true || queryData.ifPcStyle == 'true'
  },
  setTheme(state, theme) {
    state.theme = theme
  },
  clearConversationId(state) {
    state.conversationId = ''
  },
}

const actions = {
  // 定义响应组件事件的方法
}

const getters = {
  // 定义从 state 派生状态的方法
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})